<template>
  <div style="background-color: #f6f6f6;">
    <van-nav-bar title="邻友惠" right-text fixed />
    <div style="height:46px"></div>
    <van-list
      class="goodsList"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <router-link
        :to="'/hui/detail/'+item.id"
        class="item"
        v-for="item in goodsList"
        :key="item.id"
      >
        <van-image class="thumbnail" width="100%" fit="contain" radius="10px" :src="GLOBAL.IMG + item.thumbnail" />
        <div class="title">{{item.id}}{{item.post_title}}</div>
        <div class="price">¥ {{item.price}}</div>
      </router-link>
    </van-list>
    <div style="height:46px"></div>
    <TabBar active="1" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
export default {
  name: "huiList",
  components: {
    TabBar
  },
  data() {
    return {
      goodsList: [],
      loading: false,
      finished: false,
      cPage: 1
    };
  },
  methods: {
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_tuan/goods/goodsList", {
          params: { cid: 1, page: this.cPage },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.goodsList = this.goodsList.concat(data.data.data); //= data.data.data;
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.goodsList {
  text-align: left;
  .item {
    background-color: #fff;
    display: block;
    padding: 10px 10px 0 10px;
    margin-top: 10px;
   
    .title {
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0 5px 0 5px;
    }
    .price {
      color: #F40;
      font-weight: 900;
      text-align: left;
      padding: 5px 5px 5px 5px;
    }
  }
}
</style>